import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = i18n.language;
  const isSpanish = currentLang === 'es';

  const handleToggle = () => {
    const { pathname, search, hash } = location;

    let newPath: string;

    if (isSpanish) {
      // Remove /es prefix
      newPath = pathname.replace(/^\/es(\/|$)/, '/');
      if (newPath === '') newPath = '/';
      i18n.changeLanguage('en');
    } else {
      // Add /es prefix
      newPath = `/es${pathname === '/' ? '/' : pathname}`;
      i18n.changeLanguage('es');
    }

    navigate(`${newPath}${search}${hash}`);
  };

  return (
    <button
      onClick={handleToggle}
      aria-label={isSpanish ? 'Switch to English' : 'Cambiar a Espanol'}
      className="inline-flex items-center justify-center rounded-full px-3 py-1 text-xs font-semibold
        transition-colors duration-200 border
        bg-brand-yellow text-brand-yellow-foreground border-brand-yellow/60
        hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-yellow/50"
    >
      {isSpanish ? 'EN' : 'ES'}
    </button>
  );
};

export default LanguageSwitcher;
